import { useState, useEffect } from "react";
import { useLanguageContext } from "../../../../context/languageContext/LanguageContext";
import i18next from 'i18next'

import {AnimationRight, AnimationLeft, floatingAnimation} from "../../languageStyle"

export default function LanguageOption(props) {
  const daley = props.index * 0.3

  const [LanguageOptionStyle, SetLangaugeOption] = useState({})
  const { IsLanguageOptionActive, SetIsLanguageOptionActive} = useLanguageContext(); 

  
  useEffect(() => {
    if(IsLanguageOptionActive){
      SetLangaugeOption(AnimationRight(daley))
    }else{
      SetLangaugeOption(AnimationLeft(daley))
    }

  },[IsLanguageOptionActive])

  function SetLanguageTranslation(){
    i18next.changeLanguage(props.language)
    SetIsLanguageOptionActive(false)
  }
  function HoverAnimation(){
    if(IsLanguageOptionActive){
      SetLangaugeOption(floatingAnimation)
    }
  }
  function StaticAnimation(){
    if(IsLanguageOptionActive){
      SetLangaugeOption({})
    }
  }

  return (
    <button style={LanguageOptionStyle} className="LanguageOption" onClick={SetLanguageTranslation} onMouseOver={HoverAnimation} onMouseOut={StaticAnimation}>
        <span className="label">
          {props.label}
        </span>
    </button>
  );
}